(function () {
  const KEY = "pibLearningHubV3";
  const ADMIN_KEY = "pibLearningHubAdminDraftV1";
  const ADMIN_BASE_KEY = "pibLearningHubAdminLiveBaseV1";
  function liveRevision(data) {
    const text = JSON.stringify(data);
    let hash = 2166136261;
    for (let index = 0; index < text.length; index++) hash = Math.imul(hash ^ text.charCodeAt(index), 16777619);
    return `${text.length}:${hash >>> 0}`;
  }
  function selectData(central, saved, adminView, adminDraft) {
    if (!central || typeof central !== "object") return adminDraft ? JSON.parse(adminDraft) : saved ? JSON.parse(saved) : clone(window.PIB_DEFAULT_DATA);
    if (!adminView || !adminDraft) return clone(central);
    const revision = liveRevision(central);
    if (localStorage.getItem(ADMIN_BASE_KEY) === revision) {
      try { return JSON.parse(adminDraft); } catch (error) { console.warn("Draf admin tidak sah; data LIVE digunakan."); }
    }
    try {
      const backupPrefix = `pibLearningHubAdminArchiveV1:${Date.now()}`;
      let backupKey = backupPrefix;
      let suffix = 0;
      while (localStorage.getItem(backupKey) !== null) backupKey = `${backupPrefix}:${++suffix}`;
      localStorage.setItem(backupKey, adminDraft);
      localStorage.setItem(ADMIN_KEY, JSON.stringify(central));
      localStorage.setItem(ADMIN_BASE_KEY, revision);
    } catch (error) {
      console.warn("Draf lama dikekalkan; data LIVE digunakan tanpa memadam sandaran.");
    }
    return clone(central);
  }
  const clone = value => JSON.parse(JSON.stringify(value));
  const uid = prefix => `${prefix}-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 7)}`;
  const resourceNode = item => ({ id: uid("resource"), type: "resource", title: item.title || "Bahan", icon: item.icon || "↗", url: item.url || "", description: item.description || "" });
  const driveResource = (id, title, url) => ({ id, type: "resource", title, icon: "↗", url, description: "Buka folder bahan guru" });
  function seedTeacherDrive(data) {
    if (data.teacherDriveSeedV1) return data;
    const year = (id, title, children) => ({ id, type: "folder", title, children });
    const book = (id, title, children) => ({ id, type: "folder", title, children });
    const english = book("teacher-book-english", "Smart PBD AI English", [
      year("teacher-english-4", "Year 4", [
        driveResource("teacher-en4-audio-listen", "Listening Audio", "https://drive.google.com/drive/folders/1BFjMhrYKurHuWqfjIGk22pG0rh36LfqI"), driveResource("teacher-en4-erph", "e-RPH", "https://drive.google.com/drive/folders/1pOiXOXBZG3rTa1ZQQCsp0tUG-2XLG4Vx"), driveResource("teacher-en4-ebook", "e-Book", "https://drive.google.com/drive/folders/1A9cLb-h2dZ-d8yq3TDf7s-zFpy9CuCMU"), driveResource("teacher-en4-audio", "Audio", "https://drive.google.com/drive/folders/1_u2wjwLuX-yIdyNCYQCv8nvNb9BOE6ST"), driveResource("teacher-en4-resource", "Teacher’s Resource", "https://drive.google.com/drive/folders/1El4ek1wT1gefqupL5zgqnnrKrMdilmqR"), driveResource("teacher-en4-video", "Videos", "https://drive.google.com/drive/folders/1acp2wtp2E38LzXC3rdq3e0Jh-iXGloWA"), driveResource("teacher-en4-pak21", "PAK-21 Activities", "https://drive.google.com/drive/folders/14yEkEVjY_ZRuY-ZhuTrQHhbvnWRozrzh"), driveResource("teacher-en4-pbl", "Project-Based Learning", "https://drive.google.com/drive/folders/11HeR-gOU5hbq1pBL_uMhvc0-H5n7AT9d"), driveResource("teacher-en4-tmk", "TMK", "https://drive.google.com/drive/folders/1AN1iYUDsf4kitxLdnTIbdINt22l8qtC_")
      ]),
      year("teacher-english-5", "Year 5", [
        driveResource("teacher-en5-extra", "Extra Practice", "https://drive.google.com/drive/folders/1CGRA0LBRwEcHRCC57UagtZJjPq7DNk06"), driveResource("teacher-en5-audio", "Audio", "https://drive.google.com/drive/folders/1tgUkrfEaFyQKmVMsDxQy6DfwYU4zV5c2"), driveResource("teacher-en5-video", "Teaching Videos", "https://drive.google.com/drive/folders/1m8ppAqAUtYVgvRFFF04i2PTQmirJ5qKR"), driveResource("teacher-en5-ebook", "e-Books", "https://drive.google.com/drive/folders/19oeeEVUl9uFW51ByVqmmJdwjX3QZ9dgs"), driveResource("teacher-en5-erph", "e-RPH", "https://drive.google.com/drive/folders/1pPHSs4bq9VLoxBRwoh1DFVb6joQGJI48"), driveResource("teacher-en5-resource", "Teacher’s Resource", "https://drive.google.com/drive/folders/1FXOpFplDFHHQjW-RaLG0za4vcs0_pVza"), driveResource("teacher-en5-pbl", "Project-Based Learning", "https://drive.google.com/drive/folders/1nntoN7nWNODokm3kJulK5s0bAdbYMN5S"), driveResource("teacher-en5-pak21", "PAK-21", "https://drive.google.com/drive/folders/1Cdkrj2vtTd1_iAl2HNggcHX6n04qY3Fl"), driveResource("teacher-en5-tmk", "TMK", "https://drive.google.com/drive/folders/1EEzDtSWELWyNr9e0AewyGyXPqmmUoNBb"), driveResource("teacher-en5-jsi", "JSI", "https://drive.google.com/drive/folders/11Z_8p9Q_3e6EuCuvWBfGEGovo_Zmyokg")
      ]),
      year("teacher-english-6", "Year 6", [
        driveResource("teacher-en6-erph", "e-RPH", "https://drive.google.com/drive/folders/1xwA-GQa_zYJgpnQmoKXKqzJe9Y_gp8to"), driveResource("teacher-en6-ebook", "e-Books", "https://drive.google.com/drive/folders/1rJLJfgszLIg7dwBdK9e1eDnSSmj79UHS"), driveResource("teacher-en6-resource", "Teacher’s Resource", "https://drive.google.com/drive/folders/1zaPLBR-jB1VyHZB-1q_iEn4yTml3ZwHU"), driveResource("teacher-en6-audio", "Audio", "https://drive.google.com/drive/folders/1FIKMjVPpbybJIdBd7T4OXRrUaGkgavrJ"), driveResource("teacher-en6-pbl", "Project-Based Learning", "https://drive.google.com/drive/folders/1gpViN-2vq2ZLXlMoQ-nvkftsAR4v4hX1"), driveResource("teacher-en6-pak21", "PAK-21", "https://drive.google.com/drive/folders/1cYLMGzcehkXr0D_t3L_CYDSByQ1sjtaa"), driveResource("teacher-en6-tmk", "TMK", "https://drive.google.com/drive/folders/1St9SUYOHRaAQcCtueHl3YE0jNGcv2a51"), driveResource("teacher-en6-jsi", "JSI", "https://drive.google.com/drive/folders/1hQDDb401_PGWu9jCvWvT3dONa6OCyXjX")
      ])
    ]);
    const bm = book("teacher-book-bm", "Smart PBD AI Bahasa Melayu", [
      year("teacher-bm-4", "Tahun 4", [driveResource("teacher-bm4-pak21", "PAK-21", "https://drive.google.com/drive/folders/11fSoPt7lJwry2HNKiFp48wxfBekQ-j-r"), driveResource("teacher-bm4-tmk", "TMK", "https://drive.google.com/drive/folders/1S9XoT-6OVuI-xBnk3-dgDtFM8HWXaRta"), driveResource("teacher-bm4-pbp", "Pembelajaran Berasaskan Projek", "https://drive.google.com/drive/folders/1FI8j_3kHCdFSbJVOqq756kl3DtaplojC"), driveResource("teacher-bm4-guide", "Panduan Guru", "https://drive.google.com/drive/folders/1G3IqY2yXXt4xlftGRtGMQ3k_Qge2te6m"), driveResource("teacher-bm4-erph", "e-RPH", "https://drive.google.com/drive/folders/1r3wMbGNIaRHZ9zrxL0s3T8AijG7bO_et"), driveResource("teacher-bm4-ebook", "e-Buku", "https://drive.google.com/drive/folders/1j-qkUjPVvNnCJER6ImFOz-5D_sjs7fhG")]),
      year("teacher-bm-5", "Tahun 5", [driveResource("teacher-bm5-pbp", "Pembelajaran Berasaskan Projek", "https://drive.google.com/drive/folders/1jtwKu0X3qADysCYPQBDYk_3k9WtXO66i"), driveResource("teacher-bm5-pak21", "PAK-21", "https://drive.google.com/drive/folders/1ohtvmz54sYLT8ryEOStswmGDGA-Htu2K"), driveResource("teacher-bm5-tmk", "TMK", "https://drive.google.com/drive/folders/1aSNOsoTTJ_mlA_YNh5-ej5Zofsl71c4U"), driveResource("teacher-bm5-ebook", "e-Buku", "https://drive.google.com/drive/folders/1_9ywVkeYJQYVdNpKLUkqlzj3DCPIVlEW"), driveResource("teacher-bm5-erph", "e-RPH", "https://drive.google.com/drive/folders/1E8Ddi0lVMwbiSgzJCnfT6e3ban8KL9Jp"), driveResource("teacher-bm5-guide", "Panduan Guru", "https://drive.google.com/drive/folders/1orPXFcMeNKrt3RN7wzQrzWQOjZFzX2IC"), driveResource("teacher-bm5-jsi", "JSI", "https://drive.google.com/drive/folders/16pdDkizZH_uP0HddDeuehDydDsV49hSR")]),
      year("teacher-bm-6", "Tahun 6", [driveResource("teacher-bm6-pbp", "Pembelajaran Berasaskan Projek", "https://drive.google.com/drive/folders/1ai9dYUlrCqEVSSAeZadsSsK5sJHnpOmj"), driveResource("teacher-bm6-pak21", "PAK-21", "https://drive.google.com/drive/folders/18kLzmvJKwEEIaUOkE4kAF1Q2uEOg3sgy"), driveResource("teacher-bm6-tmk", "TMK", "https://drive.google.com/drive/folders/11roLANk6Xm_Ye1CplUYNnAgEKl9ScX_a"), driveResource("teacher-bm6-ebook", "e-Buku", "https://drive.google.com/drive/folders/1JrMHdujAkAMy5l3tDeFww8FA0eCfN3UZ"), driveResource("teacher-bm6-erph", "e-RPH", "https://drive.google.com/drive/folders/1GxISsRFriZi4zu_Xz5Bk_Nc_v2SZ1Wzs"), driveResource("teacher-bm6-jsi", "JSI", "https://drive.google.com/drive/folders/1voxaNnXh1iz4PI9oVEg4xEfejjZuOAtP"), driveResource("teacher-bm6-jsu", "JSU (UASA)", "https://drive.google.com/drive/folders/1r6xGjzem3j8kFSn-j3XvaOKIfFiZ_mGa")])
    ]);
    const math = book("teacher-book-math", "Smart PBD AI Matematik", [year("teacher-math-4", "Tahun 4", [driveResource("teacher-math4-ebook", "e-Buku", "https://drive.google.com/drive/folders/1ILr8-X3PLxE9zhvMacQqJpF1XFzvbOnT")])]);
    data.teacherNodes = Array.isArray(data.teacherNodes) ? data.teacherNodes : [];
    data.teacherNodes.push(english, bm, math);
    data.teacherDriveSeedV1 = true;
    data.version = 6;
    return data;
  }
  function studentBookKey(value) {
    const text = String(value || "").toLocaleLowerCase().replace(/smart\s+(pbd\s+ai|ai\s+pbd)/g, "").replace(/[^a-z0-9]+/g, " ").trim();
    if (text.includes("bahasa melayu") || text.includes("bhs melayu")) return "bm";
    if (text.includes("bahasa arab") || text.includes("bhs arab")) return "arab";
    if (text.includes("mathematics") && text.includes("dlp")) return "math-dlp";
    if (text.includes("science") && text.includes("dlp")) return "science-dlp";
    if (text.includes("pendidikan islam") || text.includes("pend islam")) return "islam";
    if (text.includes("pendidikan seni") || text.includes("psv")) return "psv";
    if (text.includes("reka bentuk") || text === "rbt") return "rbt";
    if (text.includes("matematik")) return "matematik";
    if (text.includes("sains")) return "sains";
    if (text.includes("sejarah")) return "sejarah";
    if (text.includes("english")) return "english";
    if (text.includes("jawi")) return "jawi";
    if (text.includes("muzik")) return "muzik";
    if (text.includes("pjpk")) return "pjpk";
    return text;
  }
  function studentBookTitle(key, fallback) {
    return { bm: "Bahasa Melayu", arab: "Bahasa Arab", "math-dlp": "Mathematics (DLP)", "science-dlp": "Science (DLP)", islam: "Pendidikan Islam", psv: "Pendidikan Seni Visual", rbt: "Reka Bentuk dan Teknologi", matematik: "Matematik", sains: "Sains", sejarah: "Sejarah", english: "English", jawi: "Jawi", muzik: "Muzik", pjpk: "PJPK" }[key] || fallback;
  }
  function seedStudentDrive(data) {
    if (data.studentDriveSeedV1 || !Array.isArray(window.PIB_STUDENT_DRIVE_DATA)) return data;
    const grouped = new Map();
    window.PIB_STUDENT_DRIVE_DATA.forEach(row => {
      const key = studentBookKey(row.book);
      if (!grouped.has(key)) grouped.set(key, { sourceTitle: row.book, years: [] });
      grouped.get(key).years.push(row);
    });
    data.studentBooks = Array.isArray(data.studentBooks) ? data.studentBooks : [];
    grouped.forEach((source, key) => {
      let book = data.studentBooks.find(item => studentBookKey(item.title) === key);
      if (!book) {
        book = { id: uid("book"), title: studentBookTitle(key, source.sourceTitle), description: "", cover: "", coverPosition: { x: 50, y: 50 }, years: [] };
        data.studentBooks.push(book);
      }
      source.years.forEach(sourceYear => {
        const number = String(sourceYear.year).match(/\d+/)?.[0] || sourceYear.year;
        let targetYear = book.years.find(item => (String(item.title).match(/\d+/)?.[0] || item.title) === number);
        if (!targetYear) {
          targetYear = { id: uid("bookyear"), title: sourceYear.year, accessCode: "", children: [] };
          book.years.push(targetYear);
        }
        const existingUrls = new Set((targetYear.children || []).map(item => item.url));
        const linked = sourceYear.items.filter(item => !existingUrls.has(item.url)).map(item => ({ id: `student-drive-${item.url.split("/").pop()}`, type: "resource", title: item.title, icon: "↗", url: item.url, description: "Buka bahan pembelajaran" }));
        targetYear.children = linked.concat(targetYear.children || []);
      });
    });
    data.studentDriveSeedV1 = true;
    data.version = 7;
    return data;
  }
  function isTeacherMaterial(title) {
    const name = String(title || "").toLocaleLowerCase().replace(/[’‘]/g, "'").replace(/[_–—]/g, "-").trim();
    return /(?:^|[^a-z0-9])(?:jsi|jsu|tmk|pkjr|pak\s*-?\s*21|e\s*-?\s*rph|e\s*-?\s*buku)(?=$|[^a-z0-9])/.test(name)
      || /\b(?:aktiviti\s+pak\s*-?\s*21|modul\s+literasi\s+dan\s+amali\s+sivik|modul\s+pkjr|modul\s+teknologi\s+maklumat\s+dan\s+komunikasi|pembelajaran\s+berasaskan\s+projek|project\s*-?\s*based\s+learning|panduan\s+guru|teacher'?s\s+resource)\b/.test(name);
  }
  function routeTeacherMaterial(data) {
    if (!Array.isArray(data.studentBooks)) return data;
    data.teacherNodes = Array.isArray(data.teacherNodes) ? data.teacherNodes : [];
    const folderKey = value => studentBookKey(value).replace(/[^a-z0-9]+/g, "");
    const yearKey = value => String(value || "").match(/\d+/)?.[0] || folderKey(value);
    const resourceKey = node => {
      const url = String(node.url || "");
      const driveId = url.match(/drive\.google\.com\/(?:drive\/folders|file\/d)\/([^/?#]+)/)?.[1];
      return driveId || url.split(/[?#]/)[0].replace(/\/$/, "") || node.id;
    };
    const collect = (list, moved) => (list || []).filter(node => {
      if (isTeacherMaterial(node.title)) { moved.push(node); return false; }
      if (node.type === "folder" && Array.isArray(node.children)) node.children = collect(node.children, moved);
      return true;
    });
    data.studentBooks.forEach(book => (book.years || []).forEach(year => {
      const moved = [];
      year.children = collect(year.children, moved);
      if (!moved.length) return;
      const bookTitle = `Smart PBD AI ${book.title}`;
      let teacherBook = data.teacherNodes.find(node => node.type === "folder" && folderKey(node.title) === folderKey(bookTitle));
      if (!teacherBook) {
        teacherBook = { id: `teacher-auto-${book.id}`, type: "folder", title: bookTitle, children: [] };
        data.teacherNodes.push(teacherBook);
      }
      teacherBook.children = Array.isArray(teacherBook.children) ? teacherBook.children : [];
      let teacherYear = teacherBook.children.find(node => node.type === "folder" && yearKey(node.title) === yearKey(year.title));
      if (!teacherYear) {
        teacherYear = { id: `teacher-auto-${year.id}`, type: "folder", title: year.title, children: [] };
        teacherBook.children.push(teacherYear);
      }
      teacherYear.children = Array.isArray(teacherYear.children) ? teacherYear.children : [];
      const existing = new Set(teacherYear.children.filter(node => node.type === "resource").map(resourceKey));
      moved.forEach(node => {
        if (node.type === "resource") {
          const key = resourceKey(node);
          if (existing.has(key)) return;
          existing.add(key);
        }
        teacherYear.children.push(node);
      });
    }));
    return data;
  }
  function migrateFlexibleTree(data) {
    if (Array.isArray(data.studentBooks) && Array.isArray(data.teacherNodes)) return data;
    const books = [];
    (data.years || []).forEach(year => (year.subjects || []).forEach(subject => {
      const key = (subject.title || "Buku").trim().toLocaleLowerCase();
      let book = books.find(item => item.key === key);
      if (!book) {
        book = { id: uid("book"), key, title: subject.title || "Buku", description: "", cover: subject.cover || "", coverPosition: subject.coverPosition || { x: 50, y: 50 }, years: [] };
        books.push(book);
      }
      const sourceModules = subject.modules?.length ? subject.modules : (subject.books || []).flatMap(item => item.modules || []);
      book.years.push({ id: uid("bookyear"), title: year.title || "Tahun", accessCode: year.accessCode || "", children: sourceModules.map(resourceNode) });
      if (!book.cover && subject.books?.[0]?.cover) book.cover = subject.books[0].cover;
    }));
    data.studentBooks = books.map(({ key, ...book }) => book);
    data.teacherNodes = (data.teacherModules || []).map(resourceNode);
    data.version = 5;
    return data;
  }
  function mediaKey(value) {
    let hash = 2166136261;
    for (let index = 0; index < value.length; index += 1) hash = Math.imul(hash ^ value.charCodeAt(index), 16777619);
    return `cover-${(hash >>> 0).toString(36)}-${value.length}`;
  }
  function compactMedia(data) {
    data.media = data.media && typeof data.media === "object" ? data.media : {};
    const used = new Set();
    const compactCover = item => {
      if (!item || typeof item.cover !== "string" || !item.cover) return;
      if (item.cover.startsWith("data:image/")) {
        const key = mediaKey(item.cover);
        data.media[key] = item.cover;
        item.cover = `media:${key}`;
      }
      if (item.cover.startsWith("media:")) used.add(item.cover.slice(6));
    };
    data.years.forEach(year => year.subjects.forEach(subject => {
      compactCover(subject);
      (subject.books || []).forEach(compactCover);
    }));
    Object.keys(data.media).forEach(key => { if (!used.has(key)) delete data.media[key]; });
    return data;
  }
  function compressImage(dataUrl) {
    if (!dataUrl?.startsWith("data:image/") || dataUrl.length < 260000) return Promise.resolve(dataUrl);
    return new Promise((resolve, reject) => {
      const image = new Image();
      image.onload = () => {
        const scale = Math.min(1, 1200 / image.width, 800 / image.height);
        const canvas = document.createElement("canvas");
        canvas.width = Math.max(1, Math.round(image.width * scale));
        canvas.height = Math.max(1, Math.round(image.height * scale));
        canvas.getContext("2d").drawImage(image, 0, 0, canvas.width, canvas.height);
        resolve(canvas.toDataURL("image/webp", 0.76));
      };
      image.onerror = reject;
      image.src = dataUrl;
    });
  }
  window.PIBStorage = {
    load() {
      try {
        const central = window.PIB_CENTRAL_DATA;
        const saved = localStorage.getItem(KEY);
        const adminView = new URLSearchParams(location.search).get("pibadmin") === "1";
        const adminDraft = adminView ? localStorage.getItem(ADMIN_KEY) : null;
        const data = selectData(central, saved, adminView, adminDraft);
        if (!Array.isArray(data.socialLinks)) {
          data.socialLinks = Object.entries(data.social || {}).map(([title, url], index) => ({
            id: `social-${index}-${title}`,
            title: title.charAt(0).toUpperCase() + title.slice(1),
            url
          }));
          delete data.social;
        }
        data.years.forEach(year => year.subjects.forEach(subject => {
          const firstBook = Array.isArray(subject.books) ? subject.books[0] : null;
          if (typeof subject.cover !== "string") subject.cover = firstBook?.cover || "";
          if (!Array.isArray(subject.modules)) subject.modules = firstBook?.modules || [];
        }));
        return compactMedia(routeTeacherMaterial(seedStudentDrive(seedTeacherDrive(migrateFlexibleTree(data)))));
      } catch (error) {
        console.warn("Data tersimpan tidak dapat dibaca.", error);
        return clone(window.PIB_DEFAULT_DATA);
      }
    },
    save(data) {
      routeTeacherMaterial(data);
      compactMedia(data);
      const serialized = JSON.stringify(data);
      localStorage.setItem(KEY, serialized);
      if (new URLSearchParams(location.search).get("pibadmin") === "1") {
        localStorage.setItem(ADMIN_KEY, serialized);
        if (window.PIB_CENTRAL_DATA && typeof window.PIB_CENTRAL_DATA === "object") localStorage.setItem(ADMIN_BASE_KEY, liveRevision(window.PIB_CENTRAL_DATA));
      }
    },
    resolve(data, value) {
      if (typeof value !== "string") return "";
      if (value.startsWith("media:")) return data.media?.[value.slice(6)] || "";
      if (value.startsWith("asset:")) return window.PIB_CENTRAL_ASSETS?.[value.slice(6)] || "";
      return value;
    },
    compressImage,
    async optimizeImages(data) {
      seedStudentDrive(seedTeacherDrive(migrateFlexibleTree(data)));
      routeTeacherMaterial(data);
      compactMedia(data);
      if (data.mediaOptimizedV1) return false;
      const optimized = {};
      for (const [key, value] of Object.entries(data.media)) {
        const compressed = await compressImage(value);
        optimized[mediaKey(compressed)] = compressed;
      }
      const remap = {};
      for (const [oldKey, value] of Object.entries(data.media)) remap[oldKey] = mediaKey(await compressImage(value));
      data.years.forEach(year => year.subjects.forEach(subject => {
        if (subject.cover?.startsWith("media:")) subject.cover = `media:${remap[subject.cover.slice(6)]}`;
        (subject.books || []).forEach(book => { if (book.cover?.startsWith("media:")) book.cover = `media:${remap[book.cover.slice(6)]}`; });
      }));
      data.media = optimized;
      data.mediaOptimizedV1 = true;
      this.save(data);
      return true;
    },
    export(data) {
      const blob = new Blob([JSON.stringify(data, null, 2)], { type: "application/json" });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = `pib-learning-hub-backup-${new Date().toISOString().slice(0, 10)}.json`;
      link.click();
      URL.revokeObjectURL(link.href);
    },
    async import(file) {
      const data = JSON.parse(await file.text());
      if (!data || !Array.isArray(data.years) || !Array.isArray(data.teacherModules)) throw new Error("Format fail tidak sah");
      if (!Array.isArray(data.socialLinks)) {
        data.socialLinks = Object.entries(data.social || {}).map(([title, url], index) => ({ id: `social-${index}-${title}`, title, url }));
        delete data.social;
      }
      data.years.forEach(year => year.subjects.forEach(subject => {
        const firstBook = Array.isArray(subject.books) ? subject.books[0] : null;
        if (typeof subject.cover !== "string") subject.cover = firstBook?.cover || "";
        if (!Array.isArray(subject.modules)) subject.modules = firstBook?.modules || [];
      }));
      compactMedia(data);
      this.save(data);
      return data;
    },
    reset() { localStorage.removeItem(KEY); localStorage.removeItem(ADMIN_KEY); return clone(window.PIB_DEFAULT_DATA); }
  };
})();
